

// src/routes/dashboard.routes.jsx (COMPLETE - All routes protected)
import Dashboard from '../pages/Dashboard';
import MainContent from '../pages/Dashboard/MainContent';
import Balance from '../pages/Dashboard/Balance';
import ProtectedRoute from '../components/layout/RoleProtectedRoute';
import RoleProtectedRoute from '../components/layout/RoleProtectedRoute';
import RequireUser from '../components/layout/RequireUser';
import AllOrder from '../pages/Dashboard/Orders/All';
import HeaderOrder from '../pages/Dashboard/Orders/Header';
import QuickQuote from '../pages/Dashboard/QuickQuote';
import AllInvoice from '../pages/Dashboard/Invoice/All';
import HeaderInvoice from '../pages/Dashboard/Invoice/HeaderInvoice';
import PendingForDispatch from '../pages/Dashboard/Invoice/PendingForDispatch';
import TargetAnalytics from '../pages/Dashboard/TargetAnalytics';   
import Products from '../pages/Dashboard/Products';
import Documents from '../pages/Dashboard/Documents';
import InBoundShipments from '../pages/Dashboard/InboundShipments';
import AllCustomer from '../pages/Dashboard/Customer';
// import DispatchDetails from '../pages/Dashboard/DispatchDetails';
import OrderLifeCycle from '../pages/Dashboard/OrderLifeCycle';
import Home from '../pages/Dashboard/Home';
import ContactPersonBalance from '../pages/Dashboard/ContactPersonBalance';
import CategoryAnalytics from '../pages/Dashboard/category-analytics';
import VendorBalance from '../pages/Dashboard/vendor-balance';
// Role IDs
// 1 = Contact Person - Can view orders, invoices, balance, quick quote
// 2 = Sales Person - Full access to everything
// 3 = Admin - Full access to everything

export const dashboardRoute = {
  path: '/dashboard',
  element: (
    <ProtectedRoute>
      <Dashboard />
    </ProtectedRoute>
  ),
  children: [
    {
      index: true,
      element: (
        <RequireUser>
          <RoleProtectedRoute allowedRoles={[1, 2, 3]}>
            {/* <MainContent /> */}
            <Home />
          </RoleProtectedRoute>
        </RequireUser>
      )
    },
    {
      path: 'balance',
      element: (
        <RequireUser>
          <RoleProtectedRoute allowedRoles={[1, 2, 3]}>
            <Balance />
          </RoleProtectedRoute>
        </RequireUser>
      )
    },
    {
      path: 'vendor-balance',
      element: (
        <RequireUser>
          <RoleProtectedRoute allowedRoles={[1, 2, 3]}>
            <VendorBalance />
          </RoleProtectedRoute>
        </RequireUser>
      )
    },

    {
      path: 'orders/all',
      element: (
        <RequireUser>
          <RoleProtectedRoute allowedRoles={[1, 2, 3]}>
            <AllOrder />
          </RoleProtectedRoute>
        </RequireUser>
      )
    },
    {
      path: 'orders/header',
      element: (
        <RequireUser>
          <RoleProtectedRoute allowedRoles={[1, 2, 3]}>
            <HeaderOrder />
          </RoleProtectedRoute>
        </RequireUser>
      )
    },
    {
      path: 'invoice/all',
      element: (
        <RequireUser>
          <RoleProtectedRoute allowedRoles={[1, 2, 3]}>
            <AllInvoice />
          </RoleProtectedRoute>
        </RequireUser>
      )
    },
    {
      path: 'invoice/pending',
      element: (
        <RequireUser>
          <RoleProtectedRoute allowedRoles={[1, 2, 3]}>
            <PendingForDispatch />
          </RoleProtectedRoute>
        </RequireUser>
      )
    },
    {
      path: 'invoice/header',
      element: (
        <RequireUser>
          <RoleProtectedRoute allowedRoles={[1, 2, 3]}>
            <HeaderInvoice />
          </RoleProtectedRoute>
        </RequireUser>
      )
    },
    {
      path: 'customer',
      element: (
        <RequireUser>
          <RoleProtectedRoute allowedRoles={[2, 3]}>
            <AllCustomer />
          </RoleProtectedRoute>
        </RequireUser>
      )
    },
    {
      path: 'customerbalance',
      element: (
        <RequireUser>
          <RoleProtectedRoute allowedRoles={[1]}>
            <ContactPersonBalance />
          </RoleProtectedRoute>
        </RequireUser>
      )
    },
    
    {
      path: 'products',
      element: (
        <RequireUser>
          <RoleProtectedRoute allowedRoles={[2, 3]}>
            <Products />
          </RoleProtectedRoute>
        </RequireUser>
      )
    },
    {
      path: 'documents',
      element: (
        <RequireUser>
          <RoleProtectedRoute allowedRoles={[2, 3]}>
            <Documents />
          </RoleProtectedRoute>
        </RequireUser>
      )
    },
    {
      path: 'target-analytics',
      element: (
        <RequireUser>
          <RoleProtectedRoute allowedRoles={[2, 3]}>
            <TargetAnalytics />
          </RoleProtectedRoute>
        </RequireUser>
      )
    },
    
    {
      path: 'category-analytics',
      element: (
        <RequireUser>
          <RoleProtectedRoute allowedRoles={[2, 3]}>
            <CategoryAnalytics />
          </RoleProtectedRoute>
        </RequireUser>
      )
    },
    
    
    // {
    //   path: 'dispatch-details',
    //   element: (
    //     <RequireUser>
    //       <RoleProtectedRoute allowedRoles={[2, 3]}>
    //         <DispatchDetails />
    //       </RoleProtectedRoute>
    //     </RequireUser>
    //   )
    // },
    {
      path: 'quick-quote',
      element: (
        <RequireUser>
          <RoleProtectedRoute allowedRoles={[1, 2, 3]}>
            <QuickQuote />
          </RoleProtectedRoute>
        </RequireUser>
      )
    },
    {
      path: 'inbound-shipments',
      element: (
        <RequireUser>
          <RoleProtectedRoute allowedRoles={[2, 3]}>
            <InBoundShipments />
          </RoleProtectedRoute>
        </RequireUser>
      )
    },
    {
      path: 'order-lifecycle',
      element: (
        <RequireUser>
          <RoleProtectedRoute allowedRoles={[2, 3]}>
            <OrderLifeCycle />
          </RoleProtectedRoute>
        </RequireUser>
      )
    }
  ]
};

